import './styles/shadcn.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from 'next-themes';
import { Toaster } from '@/components/ui/sonner';
import App from './App.jsx';

// next-themes stamps the theme on <html data-theme="...">, which the CSS dark
// variant and the chart tokens key off. defaultTheme="dark" — this is an internal
// ops console; the calm dark zinc is the intended default, toggle in the header.
ReactDOM.createRoot(document.getElementById('app')).render(
  <React.StrictMode>
    <ThemeProvider attribute="data-theme" defaultTheme="dark" enableSystem>
      <App />
      {/* Registry sonner emits var(--popover) etc.; our tokens are HSL triplets,
          so re-supply the toast surface vars wrapped in hsl() at the usage site
          (this style prop overrides the registry component's default). */}
      <Toaster
        position="bottom-right"
        style={{
          '--normal-bg': 'hsl(var(--popover))',
          '--normal-text': 'hsl(var(--popover-foreground))',
          '--normal-border': 'hsl(var(--border))',
          '--border-radius': 'var(--radius)',
        }}
      />
    </ThemeProvider>
  </React.StrictMode>,
);
